import React from 'react';
import ApiaryTable from './ApiaryTable';

const Apiaries = () => {
    return (
        <div style={{ width: '100%' }}>
            <ApiaryTable />
        </div>
    );
};

export default Apiaries;
